import axios from 'axios';
import { API_BASE_URL, endpoints } from './config';

// Create axios instance pointing to Django backend `/api`
const apiClient = axios.create({
    baseURL: `${API_BASE_URL}/api`,
});

// Fetch global severity counts from /api/cve/severities/
export const fetchCVESeverityCounts = async () => {
    try {
        const response = await apiClient.get('/cve/severities/');
        return response.data;
    } catch (error) {
        console.error('Error fetching CVE severity counts:', error);
        // Return zeroed structure so the UI degrades gracefully
        const empty = { count: 0, percentage: 0 };
        return { total: 0, critical: empty, high: empty, medium: empty, low: empty, unscored: empty };
    }
};

// Fetch CVE list
export const fetchCVEs = async ({ page = 1, limit = 10, search = '' }) => {
    try {
        const response = await apiClient.get(endpoints.cves.list, {
            params: { page, limit, search },
        });

        const data = response.data;

        return {
            cves: data.cves || data || [],
            total_pages: data.total_pages || 1,
            current_page: data.current_page || 1,
            has_next: data.current_page < (data.total_pages || 1),
            has_previous: data.current_page > 1,
        };
    } catch (error) {
        console.error('Error fetching CVEs:', error);
        throw new Error(error.response?.data?.detail || 'Failed to fetch CVEs');
    }
};

// Fetch CVE list from backend public proxy (precomputed CVSS fields)
export const fetchPublicCVEs = async ({ page = 1, limit = 10, search = '', severity = '' }) => {
    try {
        // Build params — omit severity when "all" or empty so upstream gets no filter param
        const params = { page, limit };
        if (search.trim()) params.search = search.trim();
        if (severity && severity !== 'all') params.severity = severity.toLowerCase();

        const response = await apiClient.get(endpoints.cves.list, { params });

        const data = response.data || {};
        const total_pages = data.total_pages || 1;
        const current_page = data.current_page || 1;

        return {
            cves: data.cves || [],
            total_pages,
            current_page,
            has_next: data?.has_next ?? current_page < total_pages,
            has_previous: data?.has_previous ?? current_page > 1,
        };
    } catch (error) {
        console.error('Error fetching public CVEs:', error);
        throw new Error(error.response?.data?.detail || 'Failed to fetch public CVEs');
    }
};
